import React from 'react';
import styles from './SummaryInfoListItem.module.scss';
import { SFText } from 'sfui';

export interface SummaryInfoListItemProps {
  className?: string;
  label: string;
  value: number | string;
}

export const SummaryInfoListItem = ({
  className = '',
  label,
  value
}: SummaryInfoListItemProps): React.ReactElement<SummaryInfoListItemProps> => {
  return (
    <div className={`${styles.summaryInfoListItem} ${className}`}>
      <span className={styles.chip}>{value}</span>
      <SFText type="component-3">{label}</SFText>
    </div>
  );
};
